import React, { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@kareo/design-system';
import FacesheetCard from 'shared-assets/facesheet-ui/components/Facesheet/Card/FacesheetCard';
import { CardTypes, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import { getMedications, getProblems, getClinicalRecommendations, getHistorySummary, getLabs, getLatestVitals, getLastVitals, getHistorySummaryUpdated, } from 'shared-assets/facesheet-ui/service/facesheet/service';
import { sortBy } from 'lodash';
import { PatientHistoryFTContext } from 'shared-assets/facesheet-ui/components/Facesheet/Container/Facesheet';
import { PatientVitalsFTContext } from 'shared-assets/facesheet-ui/components/Facesheet/Container/Facesheet';
import { UserPermissionsContext } from 'shared-assets/facesheet-ui/components/Facesheet/Container/ChartPermissionsCheck';
var buildFacesheetCards = function (patientId, widgetsState, ahrqFlag, patientStatus, userPermissions) {
    var patientHistoryContext = useContext(PatientHistoryFTContext);
    var patientVitalsContext = useContext(PatientVitalsFTContext);
    var facesheetCards = new Map([
        [
            'MEDICATIONS',
            React.createElement(FacesheetCard, { patientId: patientId, key: CardTypes.Medications, title: CardTypes.Medications, url: "/patients/" + patientId + "/medications", fetchCardData: getMedications, patientStatus: patientStatus }),
        ],
        [
            'VITALS',
            React.createElement(FacesheetCard, { patientId: patientId, key: CardTypes.Vitals, title: CardTypes.Vitals, url: "/EhrWebApp/patients/viewVitals/" + patientId, fetchCardData: patientVitalsContext ? getLastVitals : getLatestVitals }),
        ],
        [
            'LABS',
            React.createElement(FacesheetCard, { patientId: patientId, key: CardTypes.Labs, title: CardTypes.Labs, url: "/labs-ui/#/patient/" + patientId + "/labState/all", fetchCardData: getLabs }),
        ],
        [
            'PROBLEMS',
            React.createElement(FacesheetCard, { patientId: patientId, key: CardTypes.Problems, title: CardTypes.Problems, url: "/EhrWebApp/patients/viewProblems/" + patientId, fetchCardData: getProblems, patientStatus: patientStatus }),
        ],
        [
            'HISTORY',
            React.createElement(FacesheetCard, { patientId: patientId, key: CardTypes.History, title: CardTypes.History, url: "/EhrWebApp/patients/viewPatientHistory/" + patientId, fetchCardData: patientHistoryContext ? getHistorySummaryUpdated : getHistorySummary }),
        ],
        [
            'RECOMMENDATIONS',
            React.createElement(FacesheetCard, { patientId: patientId, key: CardTypes.Recommendations, title: CardTypes.Recommendations, url: "", fetchCardData: getClinicalRecommendations }),
        ],
    ]);
    if (!ahrqFlag) {
        facesheetCards.delete('RECOMMENDATIONS');
    }
    if (!(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.userPrivileges.hasLabsPrivilege)) {
        facesheetCards.delete('LABS');
    }
    widgetsState.forEach(function (widget) {
        if (!widget.enabled) {
            facesheetCards.delete(widget.widgetName);
        }
    });
    return facesheetCards;
};
var CardLayout = function (_a) {
    var patientId = _a.patientId, widgetsState = _a.widgetsState, ahrqFlag = _a.ahrqFlag, patientStatus = _a.patientStatus;
    var userPermissionContext = useContext(UserPermissionsContext);
    // cards filtered by the widget.enable setting
    var facesheetCards = buildFacesheetCards(patientId, widgetsState, ahrqFlag, patientStatus, userPermissionContext);
    // sort managed widgets by orderIndex
    var sortedWidgets = sortBy(widgetsState, ['orderIndex']);
    var displayableCards = new Map();
    // store MANAGED cards
    sortedWidgets.forEach(function (widget) {
        var managedCard = facesheetCards.get(widget.widgetName);
        if (managedCard) {
            facesheetCards.delete(widget.widgetName);
            displayableCards.set(widget.widgetName, managedCard);
        }
    });
    // store UNMANAGED cards
    facesheetCards.forEach(function (unmanagedCard, key) {
        return displayableCards.set(key, unmanagedCard);
    });
    var halfwayThrough = Math.ceil(displayableCards.size / 2);
    // split the cards evenly between the 2 columns
    var widgetValues = Array.from(displayableCards.values());
    var column1 = widgetValues.slice(0, halfwayThrough);
    var column2 = widgetValues.slice(halfwayThrough);
    return (React.createElement(Box, { display: "flex", width: "100%", height: "100%" },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(Grid, { container: true, direction: "column", spacing: 2 }, column1.map(function (widget, index) { return (React.createElement(Grid, { item: true, key: index }, widget)); }))),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(Grid, { container: true, direction: "column", spacing: 2 }, column2.map(function (widget, index) { return (React.createElement(Grid, { item: true, key: index }, widget)); }))))));
};
export default CardLayout;
